import { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'

const fontStyles = (size, weight, height) => css`
  ${size && css`
    font-size: ${size}px;
  `}
  ${weight && css`
    font-weight: ${weight};
  `}
  ${height && css`
    line-height: ${height}px;
  `}
`

// Open Sans Alt
const Arial = (size, weight, height) => css`
  ${fontStyles(size, weight, height)};
  font-family: ${Theme.fonts.Arial};
  font-stretch: normal;
  letter-spacing: 0.02em;
  transform: none;
`

// Teko Alt1
const ArialNarrow = (size, weight, height) => css`
  ${fontStyles(size, weight, height)};
  font-family: ${Theme.fonts.ArialNarrow};
  letter-spacing: 0.03em;
  font-stretch: condensed;
  transform: scale(1, 1.3);
`

// Teko Alt2
const ArialBlack = (size, weight, height) => css`
  ${fontStyles(size, weight, height)};
  font-family: ${Theme.fonts.ArialBlack};
  letter-spacing: 0.03em;
  font-stretch: condensed;
  transform: scale(1, 1.7);
`

const Factoria = (size, weight, height) => css`
  ${fontStyles(size, 400, height)};
  font-family: ${Theme.fonts.Factoria};
`

const MakoMedium = (size, weight, height) => css`
  ${fontStyles(size, 500, height)};
  font-family: ${Theme.fonts.MakoMedium};
`

const MakoBold = (size, weight, height) => css`
  ${fontStyles(size, 700, height)};
  font-family: ${Theme.fonts.MakoBold};
`

const MakoExtraBold = (size, weight, height) => css`
  ${fontStyles(size, 800, height)};
  font-family: ${Theme.fonts.MakoExtraBold};
`

const GothamMedium = (size, weight, height) => css`
  ${fontStyles(size, 500, height)};
  font-family: ${Theme.fonts.GothamMedium};
`

const GothamBold = (size, weight, height) => css`
  ${fontStyles(size, 700, height)};
  font-family: ${Theme.fonts.GothamBold};
`

const GothamLight = (size, weight, height) => css`
  ${fontStyles(size, 300, height)};
  font-family: ${Theme.fonts.GothamLight};
`

const GothamMediumItalic = (size, weight, height) => css`
  ${fontStyles(size, 500, height)};
  font-style: italic;
  font-family: ${Theme.fonts.GothamMediumItalic};
`

const GothamBookItalic = (size, weight, height) => css`
  ${fontStyles(size, 400, height)};
  font-style: italic;
  font-family: ${Theme.fonts.GothamBookItalic};
`

const GothamBook = (size, weight, height) => css`
  ${fontStyles(size, 400, height)};
  font-family: ${Theme.fonts.GothamBook};
`

export default {
  Factoria,
  Arial,
  ArialBlack,
  ArialNarrow,
  MakoMedium,
  MakoBold,
  MakoExtraBold,
  GothamMedium,
  GothamBold,
  GothamLight,
  GothamMediumItalic,
  GothamBookItalic,
  GothamBook
}
